// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: #111827 !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  height: 70px;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.navbar {
  max-width: 1400px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
}

.logo-section .brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.logo-img {
  height: 32px;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.nav-sections {
  display: flex;
  align-items: center;
  /* gap: 32px; */
}

.nav-links {
  display: flex;
  gap: 24px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e5e7eb;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.user-controls {
  display: flex;
  align-items: center;
  gap: 20px;
}

.notification-center {
  position: relative;
  padding: 8px;
  cursor: pointer;
}

.notification-center i {
  color: #e5e7eb;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #ef4444;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
}

.notification-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.notification-dropdown.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.user-profile {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: #2596be ;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

/* .user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  width: 280px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.user-profile:hover .user-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
} */

.auth-controls {
  display: flex;
  gap: 16px;
}

.auth-btn {
  padding: 8px 20px;
  border-radius: 6px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.auth-btn.login {
  color: #e5e7eb;
}

.auth-btn.register {
  background: #2596be ;
  color: white;
}

.auth-btn.register:hover {
  background: #2563eb;
}


/* Navbar styling */
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  background: #111827 !important;
  color: white;
}

.navbar-logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
}


.nav-links li {
  margin: 0 0.35rem;
}

.nav-links a {
  text-decoration: none;
  color: white;
  font-size: 1rem;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #f0f0f0;
}

.nav-buttons {
  display: flex;
  align-items: center;
}

.nav-buttons .sign-in {
  margin-right: 0.5rem;
  background: transparent;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.3s;
}

.nav-buttons .sign-in:hover {
  color: #f0f0f0;
}

.nav-buttons .get-started {
  background-color: white;
  color: #2596be;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.nav-buttons .get-started:hover {
  background-color: #f0f0f0;
  color: #20789c;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .nav-links {
    display: none;
    flex-direction: column;
  }



  .nav-links li {
    margin: 0.5rem 0;
  }

 
  .user-controls {
    margin-right: 50px !important;
  }
}
/* Container for both dropdowns
.user-controls {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  z-index: 10;
}

/* ========== NOTIFICATION DROPDOWN ========== */
/* .notification-center {
  position: relative;
  cursor: pointer;
}

.notification-center i {
  font-size: 18px;
  color: white;
}

.notification-dropdown {
  position: absolute;
  top: 40px;
  right: 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 12px;
  width: 260px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.dropdown-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
  color: #333;
}

.notification-item {
  font-size: 14px;
  color: #555;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.notification-item:last-child {
  border-bottom: none;
}

/* ========== USER DROPDOWN ========== */
.user-profile {
  position: relative;
  cursor: pointer;
}

.user-avatar {
  width: 36px;
  height: 36px;
  background-color: #1a73e8;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.user-avatar:hover {
  background-color: #0f5ec7;
}

.user-controls {
  display: flex;
  align-items: center;
  position: relative;
  gap: 20px;
}

/* 🔔 Notification Icon */
.notification-center {
  position: relative;
  cursor: pointer;
  z-index: 1001;
}

.notification-center i {
  font-size: 20px;
  color: white;
}

/* 📝 Notification Dropdown */
.notification-dropdown {
  position: absolute;
  top: 40px;
  right: 0;
  width: 280px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  padding: 12px;
  display: flex;
  flex-direction: column;
  z-index: 3000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.notification-dropdown.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.notification-dropdown .dropdown-title {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 15px;
  color: #333;
}

.notification-item {
  padding: 8px 0;
  font-size: 14px;
  color: #444;
  border-bottom: 1px solid #eee;
}

.notification-item:last-child {
  border-bottom: none;
}



/* 👤 User Profile Avatar */
.user-profile {
  position: relative;
  cursor: pointer;
  z-index: 1001;
}

.user-avatar {
  background-color: #007bff;
  color: white;
  width: 36px;
  height: 36px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  -webkit-user-select: none;
          user-select: none;
}

/* 📥 Profile Dropdown Menu */
.user-dropdown {
  position: absolute;
  top: 45px;
  right: 0;
  background-color: #121927;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  padding: 12px;
  width: 250px;
  z-index: 1000;
  border-radius: 8px;
}

.user-info {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.user-name {
  font-weight: bold;
  font-size: 15px;
  display: block;
  color: #2bb8dd;
}

.user-email {
  font-size: 14px;
  color: #fff;
  display: block;
}

/* 🧭 Dropdown Items */
.dropdown-content .dropdown-item {
  padding: 10px 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #cbc8c8;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;
}

.dropdown-content .dropdown-item:hover {
  background-color: #f4f4f4;
  color: #000;
}

.dropdown-divider {
  height: 1px;
  background-color: #ddd;
  margin: 8px 0;
}

/* 🚪 Logout Button */
.logout {
  color: #d9534f;
  font-weight: bold;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
}
@media (max-width: 768px) {
  .user-dropdown.open + .mobile-nav.open {
    display: none; 
  }
}
/* === HAMBURGER ICON === */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  cursor: pointer;
  z-index: 9002;
  margin-left: auto;      
  margin-right: -10px;      
  align-items: center;
  margin-bottom: 14px;       

}

.hamburger span {
  height: 3px;
  width: 100%;
  background-color: white;
  border-radius: 2px;
}

/* === MOBILE SIDEBAR === */
.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #2596be;
  z-index: 9002;
  padding: 80px 24px 24px;
  display: flex;
  flex-direction: column;
}

/* Close (X) Button */
.close-sidebar {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  z-index: 6000;
}

/* Mobile nav links */
.mobile-nav-list {
  list-style: none;
  padding: 0;
  margin-top: 40px;
}

.mobile-nav-list li {
  margin: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.mobile-nav-list a {
  color: white;
  font-size: 18px;
  text-decoration: none;
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
  }

  .nav-links {
    display: none !important;
  }
}
@media (min-width: 769px) {
  .nav-sections > .nav-links:first-of-type {
    flex: 1 1;
  }
}
.sidebar-open .auth-controls {
  display: none !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;GAkBG;;AAEH;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;;;EAIA;IACE,gBAAgB;EAClB;;;EAGA;IACE,6BAA6B;EAC/B;AACF;AACA;;;;;;;;;gDASgD;AAChD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;wCA4CwC;AACxC;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,SAAO;EACT;AACF;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".header {\n  background: #111827 !important;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  height: 70px;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n}\n\n.navbar {\n  max-width: 1400px;\n  margin: 0 auto;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n}\n\n.logo-section .brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n}\n\n.logo-img {\n  height: 32px;\n}\n\n.logo-text {\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.nav-sections {\n  display: flex;\n  align-items: center;\n  /* gap: 32px; */\n}\n\n.nav-links {\n  display: flex;\n  gap: 24px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #e5e7eb;\n  text-decoration: none;\n  font-weight: 500;\n  padding: 8px 12px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.nav-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.user-controls {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.notification-center {\n  position: relative;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.notification-center i {\n  color: #e5e7eb;\n}\n\n.notification-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: #ef4444;\n  color: white;\n  font-size: 12px;\n  padding: 2px 6px;\n  border-radius: 10px;\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 320px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(10px);\n  transition: all 0.3s ease;\n}\n\n.notification-dropdown.show {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.user-profile {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  background: #2596be ;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n/* .user-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  width: 280px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(10px);\n  transition: all 0.3s ease;\n}\n\n.user-profile:hover .user-dropdown {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n} */\n\n.auth-controls {\n  display: flex;\n  gap: 16px;\n}\n\n.auth-btn {\n  padding: 8px 20px;\n  border-radius: 6px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.auth-btn.login {\n  color: #e5e7eb;\n}\n\n.auth-btn.register {\n  background: #2596be ;\n  color: white;\n}\n\n.auth-btn.register:hover {\n  background: #2563eb;\n}\n\n\n/* Navbar styling */\n.navbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n  background: #111827 !important;\n  color: white;\n}\n\n.navbar-logo {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: white;\n}\n\n\n.nav-links li {\n  margin: 0 0.35rem;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: white;\n  font-size: 1rem;\n  transition: color 0.3s;\n}\n\n.nav-links a:hover {\n  color: #f0f0f0;\n}\n\n.nav-buttons {\n  display: flex;\n  align-items: center;\n}\n\n.nav-buttons .sign-in {\n  margin-right: 0.5rem;\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n\n.nav-buttons .sign-in:hover {\n  color: #f0f0f0;\n}\n\n.nav-buttons .get-started {\n  background-color: white;\n  color: #2596be;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  border: none;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.nav-buttons .get-started:hover {\n  background-color: #f0f0f0;\n  color: #20789c;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .nav-links {\n    display: none;\n    flex-direction: column;\n  }\n\n\n\n  .nav-links li {\n    margin: 0.5rem 0;\n  }\n\n \n  .user-controls {\n    margin-right: 50px !important;\n  }\n}\n/* Container for both dropdowns\n.user-controls {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  z-index: 10;\n}\n\n/* ========== NOTIFICATION DROPDOWN ========== */\n/* .notification-center {\n  position: relative;\n  cursor: pointer;\n}\n\n.notification-center i {\n  font-size: 18px;\n  color: white;\n}\n\n.notification-dropdown {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 12px;\n  width: 260px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n}\n\n.dropdown-title {\n  font-weight: bold;\n  font-size: 14px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 5px;\n  color: #333;\n}\n\n.notification-item {\n  font-size: 14px;\n  color: #555;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n/* ========== USER DROPDOWN ========== */\n.user-profile {\n  position: relative;\n  cursor: pointer;\n}\n\n.user-avatar {\n  width: 36px;\n  height: 36px;\n  background-color: #1a73e8;\n  color: white;\n  font-weight: bold;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: background-color 0.3s ease;\n}\n\n.user-avatar:hover {\n  background-color: #0f5ec7;\n}\n\n.user-controls {\n  display: flex;\n  align-items: center;\n  position: relative;\n  gap: 20px;\n}\n\n/* 🔔 Notification Icon */\n.notification-center {\n  position: relative;\n  cursor: pointer;\n  z-index: 1001;\n}\n\n.notification-center i {\n  font-size: 20px;\n  color: white;\n}\n\n/* 📝 Notification Dropdown */\n.notification-dropdown {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  width: 280px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  z-index: 3000;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(10px);\n  transition: all 0.3s ease;\n}\n\n.notification-dropdown.show {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.notification-dropdown .dropdown-title {\n  font-weight: bold;\n  margin-bottom: 10px;\n  font-size: 15px;\n  color: #333;\n}\n\n.notification-item {\n  padding: 8px 0;\n  font-size: 14px;\n  color: #444;\n  border-bottom: 1px solid #eee;\n}\n\n.notification-item:last-child {\n  border-bottom: none;\n}\n\n\n\n/* 👤 User Profile Avatar */\n.user-profile {\n  position: relative;\n  cursor: pointer;\n  z-index: 1001;\n}\n\n.user-avatar {\n  background-color: #007bff;\n  color: white;\n  width: 36px;\n  height: 36px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  user-select: none;\n}\n\n/* 📥 Profile Dropdown Menu */\n.user-dropdown {\n  position: absolute;\n  top: 45px;\n  right: 0;\n  background-color: #121927;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n  padding: 12px;\n  width: 250px;\n  z-index: 1000;\n  border-radius: 8px;\n}\n\n.user-info {\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n\n.user-name {\n  font-weight: bold;\n  font-size: 15px;\n  display: block;\n  color: #2bb8dd;\n}\n\n.user-email {\n  font-size: 14px;\n  color: #fff;\n  display: block;\n}\n\n/* 🧭 Dropdown Items */\n.dropdown-content .dropdown-item {\n  padding: 10px 8px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #cbc8c8;\n  text-decoration: none;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.dropdown-content .dropdown-item:hover {\n  background-color: #f4f4f4;\n  color: #000;\n}\n\n.dropdown-divider {\n  height: 1px;\n  background-color: #ddd;\n  margin: 8px 0;\n}\n\n/* 🚪 Logout Button */\n.logout {\n  color: #d9534f;\n  font-weight: bold;\n  background: none;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n@media (max-width: 768px) {\n  .user-dropdown.open + .mobile-nav.open {\n    display: none; \n  }\n}\n/* === HAMBURGER ICON === */\n.hamburger {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 24px;\n  height: 18px;\n  cursor: pointer;\n  z-index: 9002;\n  margin-left: auto;      \n  margin-right: -10px;      \n  align-items: center;\n  margin-bottom: 14px;       \n\n}\n\n.hamburger span {\n  height: 3px;\n  width: 100%;\n  background-color: white;\n  border-radius: 2px;\n}\n\n/* === MOBILE SIDEBAR === */\n.mobile-sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #2596be;\n  z-index: 9002;\n  padding: 80px 24px 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Close (X) Button */\n.close-sidebar {\n  position: absolute;\n  top: 20px;\n  right: 24px;\n  font-size: 28px;\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  z-index: 6000;\n}\n\n/* Mobile nav links */\n.mobile-nav-list {\n  list-style: none;\n  padding: 0;\n  margin-top: 40px;\n}\n\n.mobile-nav-list li {\n  margin: 20px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.mobile-nav-list a {\n  color: white;\n  font-size: 18px;\n  text-decoration: none;\n}\n\n@media (max-width: 768px) {\n  .hamburger {\n    display: flex;\n  }\n\n  .nav-links {\n    display: none !important;\n  }\n}\n@media (min-width: 769px) {\n  .nav-sections > .nav-links:first-of-type {\n    flex: 1;\n  }\n}\n.sidebar-open .auth-controls {\n  display: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
